import * as React from 'react';
import { CodetableMetadata } from 'app/area/import-mappings/types-store';
import styles from './category-heading.scss';

interface CategoryHeadingProps {
  codetableName: string;
  metadata: CodetableMetadata;
}

export const CategoryHeading = (props: CategoryHeadingProps) =>
  <div className={styles.headingContainer}>
    <div className={styles.column}>
      {props.codetableName}
    </div>
    <div className={styles.column}>
      {props.metadata?.codetableCategory?.label}
    </div>
  </div>;
